import React, { Component } from "react";
import { connect } from "react-redux";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import { contentClient } from "../../AxiosClient";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Trans } from "react-i18next";

const styles = (theme) => ({
  button: {
    color: theme.palette.text.secondary,
  },
});
class TemplateListItem extends Component {
  state = {
    dialogOpen: false,
  };
  render() {
    const { classes } = this.props;
    return (
      <>
        <KpsListItem
          hideExpand
          secondaryAction={
            <Tooltip title="template_delete_tooltip">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ dialogOpen: true });
                }}
                aria-label="Delete template"
              >
                <CloseIcon className={classes.button} />
              </IconButton>
            </Tooltip>
          }
          provided={false}
          selected={this.props.selected}
          onItemClick={this.props.displayTemplate.bind(
            this,
            this.props.template
          )}
        >
          <ListItemText
            style={{ direction: "ltr", overflowWrap: "anywhere" }}
            primary={this.props.template.name}
            secondary={this.props.template.description}
          />
        </KpsListItem>
        <Dialog
          open={this.state.dialogOpen}
          onClose={() => this.setState({ dialogOpen: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="delete_template_confirm_body" />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ dialogOpen: false })}
              color="primary"
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button
              onClick={this.deleteTemplate}
              color="primary"
              id="delete-template-confirm"
            >
              <Trans i18nKey="global_delete" />
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  deleteTemplate = () => {
    contentClient.delete(`/template/${this.props.template.id}`).then((res) => {
      this.setState({ dialogOpen: false });
      this.props.deleteTemplates(this.props.template.id);
    });
  };
  secondaryInfo = (settings) => {
    let { classes } = this.props;
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };
    if (!settings) {
      settings = "settings_template_description";
    }
    let info = (
      <div>
        <span className={classes.iconSpan}>
          {settings === "settings_template_description" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_template_description")}
              </div>
              <div>: {this.props.data.description}&nbsp;</div>
            </div>
          )}
          {settings === "settings_template_can_be_attached" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_template_can_be_attached")}
              </div>
              <div>: {this.props.data.canBeAttached}&nbsp;</div>
            </div>
          )}
          {settings === "settings_template_document_type" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_template_document_type")}
              </div>
              <div>: {this.props.data.documentType}&nbsp;</div>
            </div>
          )}
        </span>
      </div>
    );
    this.setState({ secondaryString: info });
  };
  extendedInfo(settings) {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (let i = 0; i < this.props.documentOptions.length; i++) {
        settings.push({ label: this.props.documentOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {setting.label === "settings_template_description" && (
                <TableCell>{this.props.data.description}</TableCell>
              )}
              {setting.label === "settings_template_can_be_attached" && (
                <TableCell>{this.props.data.canBeAttached}</TableCell>
              )}
              {setting.label === "settings_template_document_type" && (
                <TableCell>{this.props.data.documentType}</TableCell>
              )}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
}
const mapStateToProps = (state) => ({
  templateOptions: state.selectionOption.templateSettingsOptions,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(TemplateListItem));
